import axios from './request';
import { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import webConfig from './httpUrlConfig';

export type RequestConfig = Omit<AxiosRequestConfig, 'url' | 'data' | 'method' | 'params'>;

export const urlResolve = (url: string, paramsObj: { [key: string]: string }): string => {
  if (!paramsObj || !url.includes('{')) return webConfig.apiUrl + url;

  const urlArray = url.split('/').map((item) => {
    if (item.includes('{')) {
      const paramName = item.replace(/[{}\s]/g, '');
      return paramsObj[paramName];
    }
    return webConfig.apiUrl + item;
  });

  return webConfig.apiUrl + urlArray.join('/');
};

export const fetch = async (options: AxiosRequestConfig): Promise<any> => {
  const { params } = options;
  options.url = urlResolve(options.url as string, params);
  if (options.method === 'get' || options.method === 'delete') {
    const data = options.data || {};
    return await axios({
      ...options,
      ...params,
      data,
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false });
      },
    });
  }
  return await axios(options);
};
